module.exports = "https://i-jinbaozheng-network-website.oss-cn-shanghai.aliyuncs.com//img/hd-mengjianli-manifesto.18b11ccb.png";